module.exports = __webpack_public_path__ + "media/site/images/call-to-action/call-to-action-tracking@2x-e7c957c3c31c14d6bf9f883df9275c2c.png";